import React from "react";
import { UserIcon, ScanLineIcon, HelpCircleIcon, ClockIcon, LockIcon, AlertTriangleIcon, BoxIcon } from "lucide-react";
import { painPoints } from "../../data/content";
import { SectionCta } from "../SectionCta";
const iconMap: Record<string, BoxIcon> = {
  user: UserIcon,
  scan: ScanLineIcon,
  help: HelpCircleIcon,
  clock: ClockIcon,
  lock: LockIcon,
  alert: AlertTriangleIcon
};
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-236" data-mp="2hj6ulk99xoq1">
      <div className="mx-auto max-w-3xl" data-id="element-237" data-mp="2clnf6h0ub5wi">
        <h2 className="text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-238" data-mp="2ckvljbqszi8v">
          Do any of these <em className="text-brand" data-id="element-239" data-mp="2qj2au3hos9wx">sound familiar?</em>
        </h2>
        <p className="mt-3 text-center text-[17px] text-muted" data-id="element-240" data-mp="2mkw7l5g24cgr">If you answer YES to even one, I created this system for you.</p>

        <ul className="mt-10 divide-y divide-slate-200 border-y border-slate-200" data-id="element-241" data-mp="w985ijha0d1b">
          {painPoints.map(p => {
          const Icon = iconMap[p.icon];
          return <li key={p.text} className="flex items-start gap-4 py-5" data-id="element-242" data-mp="1n8v16p8lks07">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand" data-id="element-243" data-mp="1s6d86a320x5k">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-244" data-mp="1x4y808ee9eth" />
                </span>
                <p className="pt-1 text-[17px] leading-snug text-ink" data-id="element-245" data-mp="21wzgrkccsner">{p.text}</p>
              </li>;
        })}
        </ul>

        <div className="mt-10 space-y-3 text-center text-[17px] leading-relaxed text-muted" data-id="element-246" data-mp="26v9eo2pgq242">
          <p data-id="element-247" data-mp="2aw31esr65avd">
            <strong className="text-ink" data-id="element-248" data-mp="2avkxrb26fudf">The problem isn't that you're not a good dentist.</strong>
          </p>
          <p data-id="element-249" data-mp="2fueav2djxjd2">
            Most dentists were taught procedures. They weren't necessarily taught a repeatable framework for deciding{" "}
            <em className="font-semibold text-ink" data-id="element-250" data-mp="lizl4lkjjjxb">which cases to take</em> before the procedure begins.
          </p>
          <p className="font-serif text-xl font-bold text-brand" data-id="element-251" data-mp="qilycv0dd064">That's why I created Implant Case Decision™.</p>
        </div>

        <SectionCta label="Show me the system" data-id="element-252" data-mp="ihd5zwg7cy9e" />
      </div>
    </section>;
}